import type { UserRole } from '@/types';

/**
 * Every role `/settings` admits — the ONE list, imported by both the route
 * (`App.tsx`) and the header user menu that links to it (`Header.tsx`).
 *
 * C1/P1: those two had drifted. The header rendered a bare
 * `<a href="/settings">` to every logged-in role while the route admitted only
 * super_admin, country_admin and broker_admin, so a customer or a POSP opening
 * their own user menu and clicking Settings landed on Access Denied. Header's
 * own rule — "quick actions mirror the gates the destination screens already
 * enforce, so the menu can never offer someone an 'Access Denied' bounce" —
 * is now structural rather than a comment: there is a single constant, so the
 * link and the route cannot disagree again.
 *
 * The list is WIDE because `SettingsPage` is genuinely role-agnostic: every
 * field it reads comes from `/users/me/`, and its only admin-specific card is
 * separately gated by ADMIN_SETTINGS_ROLES inside the page. Nothing on it
 * assumes a broker-shaped user. `vendor_admin` is the one role left out — no
 * such login exists on this platform today.
 */
export const SETTINGS_ROLES: UserRole[] = [
  'super_admin',
  'country_admin',
  'broker_admin',
  'broker_employee',
  'insurer_admin',
  'insurer_employee',
  'posp',
  'super_posp',
  'customer',
  'audit_admin',
];

/** Roles that may hold a personal AI assistant (MCP) key — the backend's `holder_for` (Messaging Plan 4). */
export const ASSISTANT_KEY_ROLES: UserRole[] = ['posp', 'super_posp', 'broker_admin', 'broker_employee'];
